import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

const tokenClientSlice = createSlice({
  name: "clinetToken",
  initialState,
  reducers: {
    setClientTokenInStore: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setClientTokenInStore } = tokenClientSlice.actions;

export default tokenClientSlice.reducer;